/*
 * Velora "Rakd egymásra" stack offer (snippets/velora-stack-offer.liquid).
 *
 * Row 1 (default): nothing changes, the native Shrine buy button works as before.
 * Row 2: the main product + one curated pair go into the cart with ONE /cart/add.js request,
 * every line tagged with _velora_stack (shared id) and _velora_stack_size.
 * The shown set price is display only: the real discount is a Shopify automatic discount (see the snippet).
 *
 * Idempotent, survives AJAX re-renders (body observer re-inits a replaced block), no globals except
 * window.VeloraStack.scan.
 */
(function () {
  'use strict';

  if (window.__veloraStackLoaded) {
    if (window.VeloraStack) window.VeloraStack.scan();
    return;
  }
  window.__veloraStackLoaded = true;

  var ROOT = '[data-velora-stack]';
  var saved = {}; // per product id: survives a re-render of the block on the same page

  var TXT = {
    more: function (n) { return 'Válassz még ' + n + ' darabot'; },
    setButton: function (total) { return 'Szett a kosárba · ' + total; },
    adding: 'Hozzáadás…',
    error: 'Nem sikerült a kosárba tenni. Próbáld újra.',
    errorShort: 'Próbáld újra',
    unavailable: 'Ebben a színben most nem elérhető',
    pickOne: 'Mivel viselnéd együtt?',
    setPrice: 'Szett ár: ',
    freeShipping: 'Ingyenes szállítás',
    saving: function (amount) { return 'Megtakarítasz ' + amount; },
    cardLabel: function (title, price) { return title + ', ' + price; }
  };

  /* ---------- helpers ---------- */

  function norm(value) {
    // lowercase, accents removed (á -> a, ő -> o): non-ASCII leftovers after NFD are the combining marks
    return String(value).normalize('NFD').replace(/[^\x00-\x7f]/g, '').toLowerCase();
  }

  // Plating of an option value list: 'sarga' (yellow gold), 'feher' (white gold) or null.
  function platingKey(values) {
    for (var i = 0; i < values.length; i++) {
      var n = norm(values[i]);
      if (n.indexOf('sarga') > -1) return 'sarga';
      if (n.indexOf('feher') > -1) return 'feher';
    }
    return null;
  }

  // Self pairs differ only in Bevonat (or option 1), never in an unchosen size.
  function otherPlatingVariant(data, main, platingIdx) {
    return data.variants.filter(function (v) {
      return v.available && v.options[platingIdx] !== main.options[platingIdx] &&
        v.options.every(function (value, idx) { return idx === platingIdx || value === main.options[idx]; });
    })[0] || null;
  }

  function selfPairVariant(pair, main, mainChanged) {
    if (pair.touched) {
      var chosen = pair.data.variants.filter(function (v) {
        return v.available && v.options[pair.platingIdx] === pair.platingSel &&
          pair.extras.every(function (o) { return pair.sel[o.idx] === undefined || v.options[o.idx] === pair.sel[o.idx]; });
      })[0];
      // Equality is allowed after a deliberate card choice, but never caused by the main picker.
      if (chosen && !(mainChanged && String(chosen.id) === String(main.id))) return chosen;
    }
    return otherPlatingVariant(pair.data, main, pair.platingIdx);
  }

  function pairTitle(pair) {
    return pair.data.title + (pair.data.self && pair.variant ? ' · ' + pair.variant.options[pair.platingIdx] : '');
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function groupNumber(n, decimals, thousands, decimal) {
    var parts = (n / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[0] + (parts[1] ? decimal + parts[1] : '');
  }

  // Same placeholders as Shopify's money formats, so JS prices match the Liquid prices.
  function formatMoney(cents, format) {
    var pattern = /\{\{\s*(\w+)\s*\}\}/;
    var template = (format || '{{amount_no_decimals}} Ft').replace(/<[^>]*>/g, '');
    return template.replace(pattern, function (match, name) {
      var out;
      switch (name) {
        case 'amount': out = groupNumber(cents, 2, ',', '.'); break;
        case 'amount_no_decimals': out = groupNumber(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': out = groupNumber(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = groupNumber(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': out = groupNumber(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': out = groupNumber(cents, 0, ' ', '.'); break;
        case 'amount_with_apostrophe_separator': out = groupNumber(cents, 2, "'", '.'); break;
        case 'amount_with_period_and_space_separator': out = groupNumber(cents, 2, ' ', '.'); break;
        default: out = groupNumber(cents, 0, '.', ',');
      }
      return name.indexOf('no_decimals') < 0 ? out.replace(/[.,]00$/, '') : out;
    });
  }

  // Old or invalid set sizes fall back to the native single-product offer.
  function stackSize(value) { return Number(value) === 2 ? 2 : 1; }

  // Explicit URL choices win; otherwise restore this product's saved session choice.
  function restoredStackState(state, href) {
    try {
      var params = new URL(href).searchParams;
      if (params.has('stack_pair') || params.has('stack_size')) {
        var id = params.get('stack_pair');
        return { size: params.get('stack_size') || (id ? 2 : 1), picked: id ? [id] : [], sel: [] };
      }
    } catch (e) { /* ignore */ }
    return state;
  }

  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function setHidden(el, hidden) { if (el && el.hidden !== hidden) el.hidden = hidden; }
  function setAttr(el, name, value) { if (el && el.getAttribute(name) !== value) el.setAttribute(name, value); }

  function imageSet(url, width) { return url.replace(/([?&])width=\d+/, '$1width=' + width); }

  function newStackId() {
    var rand = '';
    try {
      var buf = new Uint32Array(2);
      window.crypto.getRandomValues(buf);
      rand = buf[0].toString(36) + buf[1].toString(36);
    } catch (e) {
      rand = Math.random().toString(36).slice(2, 12);
    }
    return 'vs' + Date.now().toString(36) + rand;
  }

  /* ---------- one stack block ---------- */

  function init(root) {
    var cfgEl = root.querySelector('[data-stack-config]');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);

    var mainById = {};
    cfg.variants.forEach(function (v) { mainById[String(v.id)] = v; });

    var els = {
      radios: Array.prototype.slice.call(root.querySelectorAll('[data-stack-size]')),
      choices: root.querySelector('[data-stack-choices]'),
      label: root.querySelector('[data-stack-choice-label]'),
      summary: root.querySelector('[data-stack-summary]'),
      error: root.querySelector('[data-stack-error]'),
      singlePrice: root.querySelector('[data-stack-single-price]'),
      ship2: root.querySelector('[data-stack-ship="2"]')
    };

    var scope = root.closest('.shopify-section') || document;
    var watchRoot = root.closest('.product__info-container') || scope;

    var st = {
      size: 1,
      picked: [],          // pair objects, oldest first
      main: mainById[String(cfg.initialVariant)] || cfg.variants[0],
      busy: false,
      origLabel: null,     // native button label before we changed it
      hidQty: [],
      destroyed: false
    };

    /* pairs */
    var cards = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-stack-card]'), function (card) {
      cards[card.getAttribute('data-pair-id')] = card;
    });

    var pairs = [];
    cfg.pairs.forEach(function (p) {
      var card = cards[String(p.id)];
      if (!card) return;
      var platingIdx = -1;
      if (p.self) {
        platingIdx = p.platingIndex;
      } else {
        for (var k = 0; k < p.options.length; k++) {
          if (p.variants.some(function (v) { return platingKey([v.options[k]]) !== null; })) { platingIdx = k; break; }
        }
      }
      var extras = [];
      p.options.forEach(function (name, k) {
        if (k === platingIdx) return;
        var values = [];
        p.variants.forEach(function (v) { if (values.indexOf(v.options[k]) < 0) values.push(v.options[k]); });
        if (values.length > 1) extras.push({ idx: k, name: name, values: values });
      });
      var platings = [];
      if (platingIdx > -1) {
        p.variants.forEach(function (v) { if (platings.indexOf(v.options[platingIdx]) < 0) platings.push(v.options[platingIdx]); });
      }
      var pair = {
        data: p,
        card: card,
        button: card.querySelector('[data-stack-pair]'),   // the info area is the real control
        badge: card.querySelector('[data-stack-badge]'),   // decorative check on the image
        slides: card.querySelector('[data-stack-slides]'),
        img: card.querySelector('.velora-stack__slide img'),   // slide 1: the matching variant image
        price: card.querySelector('[data-stack-price]'),
        optionsBox: card.querySelector('[data-stack-options]'),
        swatchBox: card.querySelector('[data-stack-swatches]'),
        platingIdx: platingIdx,
        platings: platings,      // distinct plating option values of this product
        platingSel: null,        // plating the shopper chose on this card
        touched: false,          // true once the shopper touched a swatch; until then the card follows the main plating
        platingValue: null,      // plating actually shown now
        swatches: {},            // plating value -> button
        extras: extras,
        sel: {},           // extra option idx -> chosen value
        pills: {},         // extra option idx -> { value: button }
        variant: null,     // resolved variant (the available one, else a candidate for display)
        available: false
      };
      buildSwatches(pair);
      buildPills(pair);
      initSlides(pair);
      pairs.push(pair);
    });
    if (!pairs.length) return;

    // Swipeable mini gallery: dots follow the scroll, the 3rd image loads on the first touch or swipe.
    function initSlides(pair) {
      var slides = pair.slides;
      if (!slides) return;
      var dots = pair.card.querySelectorAll('.velora-stack__dots span');
      function hydrate() {
        if (slides.getAttribute('data-hydrated')) return;
        slides.setAttribute('data-hydrated', '1');
        Array.prototype.forEach.call(slides.querySelectorAll('img[data-stack-defer]'), function (img) {
          if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
          if (img.getAttribute('data-src')) img.src = img.getAttribute('data-src');
          img.removeAttribute('data-stack-defer');
        });
      }
      slides.addEventListener('pointerdown', hydrate, { passive: true });
      slides.addEventListener('scroll', function () {
        hydrate();
        var index = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth + 1)); // + the 1px gap between slides
        Array.prototype.forEach.call(dots, function (dot, i) { dot.classList.toggle('is-active', i === index); });
      }, { passive: true });
    }

    function buildSwatches(pair) {
      if (!pair.swatchBox || pair.platings.length < 2) return;
      pair.platings.forEach(function (value) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'velora-stack__swatch';
        b.setAttribute('data-plating', platingKey([value]) || 'other');
        b.setAttribute('aria-label', value);
        b.setAttribute('aria-pressed', 'false');
        var dot = document.createElement('span');
        dot.className = 'velora-stack__dot';
        dot.setAttribute('aria-hidden', 'true');
        b.appendChild(dot);
        b.addEventListener('click', function () {
          pair.touched = true;
          pair.platingSel = value;
          resolvePair(pair);
          // Tapping a swatch also selects the card (fewer taps) but only when there is room: it never swaps
          // another card out. An already selected card just changes colour.
          if (st.picked.indexOf(pair) < 0 && pair.available && canAddPick()) addPick(pair);
          hideError();
          render();
          persist();
          announce();
        });
        pair.swatches[value] = b;
        pair.swatchBox.appendChild(b);
      });
      pair.swatchBox.hidden = false;
    }

    function buildPills(pair) {
      pair.extras.forEach(function (extra) {
        var fieldset = document.createElement('fieldset');
        fieldset.className = 'velora-stack__option';
        var legend = document.createElement('legend');
        legend.textContent = extra.name;
        fieldset.appendChild(legend);
        var wrap = document.createElement('div');
        wrap.className = 'velora-stack__pills';
        pair.pills[extra.idx] = {};
        extra.values.forEach(function (value) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'velora-stack__pill';
          b.textContent = value.indexOf(' - ') > -1 ? value.split(' - ').pop() : value;
          b.setAttribute('aria-label', extra.name + ': ' + value);
          b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', function () {
            if (pair.data.self) {
              pair.touched = true;
              pair.platingSel = pair.platingValue;
            }
            pair.sel[extra.idx] = value;
            resolvePair(pair);
            renderPair(pair);
            render();
            persist();
            announce();
          });
          pair.pills[extra.idx][value] = b;
          wrap.appendChild(b);
        });
        fieldset.appendChild(wrap);
        pair.optionsBox.appendChild(fieldset);
      });
    }

    /* ---------- pair variant resolution ---------- */

    function hasAvailable(pair, platingValue) {
      return pair.data.variants.some(function (v) {
        return v.available && (pair.platingIdx < 0 || v.options[pair.platingIdx] === platingValue) &&
          (!pair.data.self || pair.extras.every(function (o) { return pair.sel[o.idx] === undefined || v.options[o.idx] === pair.sel[o.idx]; }));
      });
    }

    // Plating shown on a card: the shopper's own choice once touched, else the main product's plating.
    // A sold-out plating switches to the available one instead of disabling the card.
    function wantedPlating(pair) {
      if (pair.platingIdx < 0) return null;
      var want = null;
      if (pair.touched && pair.platings.indexOf(pair.platingSel) > -1) {
        want = pair.platingSel;
      } else {
        var key = platingKey([st.main.options.join(' ')]);
        if (key) {
          want = pair.platings.filter(function (v) { return platingKey([v]) === key; })[0] || null;
        }
        if (!want) want = pair.platings[0];
      }
      if (!hasAvailable(pair, want)) {
        var alt = pair.platings.filter(function (v) { return hasAvailable(pair, v); })[0];
        if (alt !== undefined) want = alt;
      }
      return want;
    }

    function candidates(pair) {
      if (pair.platingIdx < 0) return pair.data.variants;
      return pair.data.variants.filter(function (v) { return v.options[pair.platingIdx] === pair.platingValue; });
    }

    function resolvePair(pair, mainChanged) {
      if (pair.data.self) {
        pair.variant = selfPairVariant(pair, st.main, mainChanged === true);
        pair.available = !!pair.variant;
        if (pair.variant) {
          pair.platingValue = pair.variant.options[pair.platingIdx];
          if (pair.touched) pair.platingSel = pair.platingValue;
          pair.extras.forEach(function (o) { pair.sel[o.idx] = pair.variant.options[o.idx]; });
        }
        pair.platings.forEach(function (value) {
          var swatch = pair.swatches[value];
          if (!swatch) return;
          swatch.disabled = !hasAvailable(pair, value);
          setAttr(swatch, 'aria-pressed', pair.available && pair.platingValue === value ? 'true' : 'false');
        });
        pair.extras.forEach(function (extra) {
          extra.values.forEach(function (value) {
            var pill = pair.pills[extra.idx][value];
            pill.disabled = !pair.data.variants.some(function (v) {
              return v.available && v.options[pair.platingIdx] === pair.platingValue && v.options[extra.idx] === value &&
                pair.extras.every(function (o) { return o.idx === extra.idx || v.options[o.idx] === pair.sel[o.idx]; });
            });
            setAttr(pill, 'aria-pressed', pair.available && pair.sel[extra.idx] === value ? 'true' : 'false');
          });
        });
        if (!pair.available) {
          var selfAt = st.picked.indexOf(pair);
          if (selfAt > -1) st.picked.splice(selfAt, 1);
        }
        return;
      }
      pair.platingValue = wantedPlating(pair);
      pair.platings.forEach(function (value) {
        var swatch = pair.swatches[value];
        if (!swatch) return;
        var isAvailable = hasAvailable(pair, value);
        if (swatch.disabled !== !isAvailable) swatch.disabled = !isAvailable;
        setAttr(swatch, 'aria-pressed', pair.platingValue === value ? 'true' : 'false');
      });
      var list = candidates(pair);
      pair.extras.forEach(function (extra) {
        var others = list.filter(function (v) {
          return pair.extras.every(function (o) {
            return o.idx === extra.idx || pair.sel[o.idx] === undefined || v.options[o.idx] === pair.sel[o.idx];
          });
        });
        var availableValues = extra.values.filter(function (value) {
          return others.some(function (v) { return v.options[extra.idx] === value && v.available; });
        });
        var anyValues = extra.values.filter(function (value) {
          return others.some(function (v) { return v.options[extra.idx] === value; });
        });
        if (availableValues.indexOf(pair.sel[extra.idx]) < 0) {
          pair.sel[extra.idx] = availableValues[0] !== undefined ? availableValues[0] : anyValues[0];
        }
        var buttons = pair.pills[extra.idx];
        extra.values.forEach(function (value) {
          var pill = buttons[value];
          var isAvailable = availableValues.indexOf(value) > -1;
          if (pill.disabled !== !isAvailable) pill.disabled = !isAvailable;
          setAttr(pill, 'aria-pressed', pair.sel[extra.idx] === value ? 'true' : 'false');
        });
      });
      var matches = list.filter(function (v) {
        return pair.extras.every(function (o) { return pair.sel[o.idx] === undefined || v.options[o.idx] === pair.sel[o.idx]; });
      });
      pair.variant = matches.filter(function (v) { return v.available; })[0] || matches[0] || list[0] || null;
      pair.available = !!(pair.variant && pair.variant.available);
      if (!pair.available) {
        var at = st.picked.indexOf(pair);
        if (at > -1) st.picked.splice(at, 1);
      }
    }

    function minPrice(pair) {
      if (pair.data.self && !pair.available) return null;
      var prices = pair.data.variants.filter(function (v) { return v.available; }).map(function (v) { return v.price; });
      return prices.length ? Math.min.apply(null, prices) : null;
    }

    /* ---------- rendering ---------- */

    // Credit shown on a pair card: the full two-piece set discount.
    function pairCredit() {
      if (st.size === 2) return cfg.discounts['2'] || 0;
      return 0;
    }

    function renderPairPrice(pair, v) {
      var credit = pairCredit();
      var full = formatMoney(v.price, cfg.moneyFormat);
      var key = credit > 0 ? st.size + '|' + full + '|' + credit : 'plain|' + full;
      if (pair.priceKey === key) return;
      pair.priceKey = key;
      if (!credit) { pair.price.textContent = full; return; }
      var net = formatMoney(Math.max(v.price - credit, 0), cfg.moneyFormat);
      var label = money(credit) + '-tal olcsóbban';
      pair.price.textContent = '';
      [['velora-stack__price-was', full, 's'], ['velora-stack__price-now', net, 'span'], ['velora-stack__price-credit', label, 'span']].forEach(function (d) {
        var el = document.createElement(d[2]);
        el.className = d[0];
        el.textContent = d[1];
        pair.price.appendChild(el);
      });
    }

    function renderPair(pair) {
      if (pair.data.self) setHidden(pair.card, !pair.available);
      var v = pair.variant;
      if (v) {
        renderPairPrice(pair, v);
        if (pair.img && v.image && pair.img.getAttribute('data-stack-src') !== v.image) {
          pair.img.setAttribute('data-stack-src', v.image);
          pair.img.src = imageSet(v.image, 320);
          pair.img.srcset = [160, 240, 320, 400].map(function (w) { return imageSet(v.image, w) + ' ' + w + 'w'; }).join(', ');
          if (pair.slides && pair.slides.scrollLeft > 0) pair.slides.scrollTo({ left: 0 });
        }
      }
      var picked = st.picked.indexOf(pair) > -1;
      if (pair.button.disabled !== !pair.available) pair.button.disabled = !pair.available;
      setAttr(pair.button, 'aria-pressed', picked ? 'true' : 'false');
      if (v) setAttr(pair.button, 'aria-label', TXT.cardLabel(pairTitle(pair), formatMoney(Math.max(v.price - pairCredit(), 0), cfg.moneyFormat)) + (pairCredit() ? ', ' + money(pairCredit()) + '-tal olcsóbban' : ''));
      setHidden(pair.badge, !picked);
      setHidden(pair.optionsBox, !(picked && pair.extras.length));
    }

    function money(cents) { return formatMoney(cents, cfg.moneyFormat); }

    function totals() {
      var full = st.main.price;
      st.picked.forEach(function (p) { full += p.variant.price; });
      var discount = st.size === 2 ? (cfg.discounts['2'] || 0) : 0;
      return { full: full, total: Math.max(full - discount, 0), discount: discount };
    }

    function isComplete() {
      return st.size === 2 && st.main.available && st.picked.length === 1 &&
        st.picked.every(function (p) { return p.available && p.variant; });
    }

    var ship = { 2: false }; // free shipping reachable per row (same rule as the row tags)

    // Progress message for the (visually hidden) live region; empty when nothing is left to choose.
    function progressText() {
      if (st.size === 1 || !st.main.available || isComplete()) return '';
      var amount = '\u2212' + money(cfg.discounts['2']);
      return 'Egy darab kell hozzá: ' + amount + (ship[2] ? ' és ingyenes szállítás' : '') + '.';
    }

    function render() {
      if (st.destroyed) return;
      // radios
      els.radios.forEach(function (r) { r.checked = Number(r.value) === st.size; });
      setText(els.singlePrice, money(st.main.price));
      setHidden(els.choices, st.size === 1);
      setText(els.label, TXT.pickOne);

      // free-shipping hint of the rows: cheapest possible set, discount subtracted
      var mins = pairs.map(minPrice).filter(function (p) { return p !== null; }).sort(function (a, b) { return a - b; });
      ship[2] = mins.length >= 1 && st.main.price + mins[0] - cfg.discounts['2'] >= cfg.threshold;
      if (els.ship2) setHidden(els.ship2, !ship[2]);

      pairs.forEach(renderPair);
      renderSummary();
      applyNative();
      renderBar();
    }

    function renderSummary() {
      if (!els.summary) return;
      var html = null;
      if (st.size === 1) {
        html = '';
      } else if (!st.main.available) {
        html = '<span>' + TXT.unavailable + '</span>';
      } else if (isComplete()) {
        var t = totals();
        var pairLine = st.picked[0].data.self ? '<span>' + escapeHtml(pairTitle(st.picked[0])) + '</span>' : '';
        html = pairLine + '<span>' + TXT.setPrice + '<s>' + money(t.full) + '</s><strong>' + money(t.total) + '</strong></span>' +
          '<span class="velora-stack__shipping">' + TXT.saving(money(t.discount)) +
          (t.total >= cfg.threshold ? ' \u00b7 ' + TXT.freeShipping : '') + '</span>';
      } else {
        // progress is announced to screen readers only (live region)
        html = '<span class="velora-stack__sr">' + progressText() + '</span>';
      }
      if (els.summary.getAttribute('data-html') !== html) {
        els.summary.setAttribute('data-html', html);
        els.summary.innerHTML = html; // static strings, formatted numbers and an escaped self-pair label
      }
    }

    /* ---------- native buy button, quantity selector ---------- */

    // The page can have several /cart/add forms (Shopify's installment form has a hidden id input and no
    // buttons). The product form is the one with data-velora-base-form, else the first one with a submit button.
    function mainForm() {
      var forms = Array.prototype.filter.call(scope.querySelectorAll('form[action*="/cart/add"]'), function (f) {
        return !root.contains(f);
      });
      var withId = forms.filter(function (f) {
        var input = f.querySelector('input[name="id"], select[name="id"]');
        return input && mainById[String(input.value)];
      });
      var pick = function (list) {
        return list.filter(function (f) { return f.hasAttribute('data-velora-base-form'); })[0] ||
          list.filter(function (f) { return f.querySelector('button[name="add"], button[type="submit"], input[type="submit"]'); })[0];
      };
      return pick(withId) || pick(forms) || withId[0] || null;
    }

    function mainInput() {
      var form = mainForm();
      return form ? form.querySelector('input[name="id"], select[name="id"]') : null;
    }

    function readMainVariant() {
      var input = mainInput();
      if (input && mainById[String(input.value)]) return mainById[String(input.value)];
      try {
        var fromUrl = new URL(window.location.href).searchParams.get('variant');
        if (fromUrl && mainById[fromUrl]) return mainById[fromUrl];
      } catch (e) { /* ignore */ }
      return null;
    }

    function nativeButton() {
      var form = mainForm();
      return form ? form.querySelector('button[name="add"], button[type="submit"]') : null;
    }

    function isOurLabel(text) {
      return text.indexOf('Válassz még') === 0 || text.indexOf('Szett a kosárba') === 0 || text === TXT.adding;
    }

    function applyNative() {
      var btn = nativeButton();
      var labelEl = btn && (btn.querySelector('.product-form__submit-label') ||
        btn.querySelector('.main-atc__label__text') || btn.querySelector('.button__label') ||
        btn.querySelector(':scope > span') || btn);
      var setMode = st.size > 1 && st.main.available;
      var complete = isComplete();
      var total = complete ? money(totals().total) : '';

      if (btn && labelEl) {
        var current = labelEl.textContent.trim();
        if (setMode) {
          if (!isOurLabel(current)) st.origLabel = current;
          var wanted = st.busy ? TXT.adding : (complete ? TXT.setButton(total) : TXT.more(st.size - 1 - st.picked.length));
          if (current !== wanted) labelEl.textContent = wanted;
          var disabled = st.busy || !complete;
          if (btn.disabled !== disabled) btn.disabled = disabled;
          setAttr(btn, 'data-velora-stack', 'on');
          setAttr(btn, 'aria-busy', st.busy ? 'true' : 'false');
        } else if (btn.getAttribute('data-velora-stack') === 'on') {
          btn.removeAttribute('data-velora-stack');
          btn.removeAttribute('aria-busy');
          if (isOurLabel(current) && st.origLabel) labelEl.textContent = st.origLabel;
          if (st.main.available && btn.disabled) btn.disabled = false;
        }
      }

      // quantity selector: hidden while a set is chosen (every set line is quantity 1)
      var qty = scope.querySelectorAll('.product-form__quantity, quantity-input.main-quantity');
      Array.prototype.forEach.call(qty, function (el) {
        if (root.contains(el)) return;
        if (setMode) {
          if (el.style.display !== 'none') { el.style.display = 'none'; el.setAttribute('data-velora-stack-hid', '1'); }
        } else if (el.getAttribute('data-velora-stack-hid') === '1') {
          el.style.display = '';
          el.removeAttribute('data-velora-stack-hid');
        }
      });

      watchNative(btn);
    }

    /* ---------- sticky set bar (replaces the legacy #StickyATC while a set is chosen) ---------- */

    var bar = null;
    var barEls = null;
    var barOn = false;
    var barSig = '';
    var barHideTimer = null;
    var nativeInView = true;     // until the observer says otherwise the bar stays hidden
    var observedBtn = null;
    var barIO = null;
    var ioReported = false;      // has the observer reported at least once for the current button?
    var fallbackTimer = null;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function createBar() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-velora-stack-bar]'), function (el) { el.remove(); });
      var el = document.createElement('div');
      el.className = 'velora-stack-bar';
      el.setAttribute('data-velora-stack-bar', '');
      el.setAttribute('role', 'region');
      el.setAttribute('aria-label', 'Szett összegzése');
      el.hidden = true;
      el.inert = true;
      el.innerHTML = '<div class="velora-stack-bar__inner">' +
        '<div class="velora-stack-bar__thumbs" aria-hidden="true"></div>' +
        '<div class="velora-stack-bar__info"><span class="velora-stack-bar__l1"></span><span class="velora-stack-bar__l2"></span></div>' +
        '<button type="button" class="velora-stack-bar__btn">Kosárba</button></div>';
      document.body.appendChild(el);
      bar = el;
      barEls = {
        thumbs: el.querySelector('.velora-stack-bar__thumbs'),
        l1: el.querySelector('.velora-stack-bar__l1'),
        l2: el.querySelector('.velora-stack-bar__l2'),
        btn: el.querySelector('.velora-stack-bar__btn')
      };
      barEls.btn.addEventListener('click', onBarClick);
      if ('IntersectionObserver' in window) {
        barIO = new IntersectionObserver(function (entries) {
          ioReported = true;
          entries.forEach(function (entry) { if (entry.target === observedBtn) nativeInView = entry.isIntersecting; });
          renderBar();
        });
      }
      window.addEventListener('scroll', onScrollCheck, { passive: true });
      window.addEventListener('resize', onResizeBar);
    }

    // Synchronous fallback for the observer (its callbacks do not fire while the document is hidden):
    // is any part of the native button inside the viewport?
    function rectInView(btn) {
      if (!btn) return false;
      var r = btn.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
    }

    function checkNative() {
      if (!bar || st.destroyed) return;
      nativeInView = rectInView(nativeButton());
      renderBar();
    }

    var scrollQueued = false;
    function onScrollCheck() {
      if (scrollQueued) return;
      scrollQueued = true;
      window.requestAnimationFrame(function () { scrollQueued = false; if (alive()) checkNative(); });
    }

    function onResizeBar() {
      if (!alive()) return;
      updatePreviewOffset();
      checkNative();
      if (barOn) measureBar();
    }

    // The preview bar of an unpublished theme (cross-origin iframe #PBarNextFrame) overlaps the bottom edge of the
    // screen. On the live theme the iframe does not exist and the offset is 0, so nothing changes there.
    function updatePreviewOffset() {
      var root = document.documentElement;
      var offset = document.getElementById('PBarNextFrame') ? (window.innerWidth < 750 ? 72 : 64) : 0;
      var value = offset ? offset + 'px' : '';
      if ((root.style.getPropertyValue('--vs-preview-offset') || '') === value) return;
      if (value) root.style.setProperty('--vs-preview-offset', value); else root.style.removeProperty('--vs-preview-offset');
    }

    // The bar shows only while the native add-to-cart button is out of the viewport (never two buttons on screen).
    function watchNative(btn) {
      if (!barIO || btn === observedBtn) return;
      if (observedBtn) barIO.unobserve(observedBtn);
      observedBtn = btn;
      ioReported = false;
      nativeInView = true;
      if (btn) barIO.observe(btn); else nativeInView = false;
    }

    function setBarHtml(el, html) {
      if (el.getAttribute('data-html') !== html) { el.setAttribute('data-html', html); el.innerHTML = html; }
    }

    function tile(slot) {
      if (slot.empty) return '<span class="velora-stack-bar__tile is-empty">+</span>';
      return '<span class="velora-stack-bar__tile">' + (slot.img ? '<img alt="" src="' + slot.img + '">' : '') + '</span>';
    }

    function renderBar() {
      if (!bar || st.destroyed) return;
      var setMode = st.size > 1 && st.main.available;
      var root = document.documentElement;
      if (setMode) root.setAttribute('data-velora-stack-set', ''); else root.removeAttribute('data-velora-stack-set');
      updatePreviewOffset();
      // If the observer has not reported shortly after set mode starts, decide with a synchronous check instead.
      if (setMode && !ioReported && !fallbackTimer) {
        fallbackTimer = window.setTimeout(function () {
          fallbackTimer = null;
          if (alive() && !ioReported) checkNative();
        }, 400);
      }

      if (setMode) {
        // Thumbs: the main product and its one partner, or an empty partner slot.
        var p = st.picked[0];
        var slots = [{ img: st.main.image }, p ? { img: p.variant && p.variant.image ? imageSet(p.variant.image, 120) : null } : { empty: true }];
        var sig = slots.map(function (sl) { return sl.empty ? 'e' : (sl.img || 'x'); }).join('|');
        if (sig !== barSig) { barSig = sig; barEls.thumbs.innerHTML = slots.map(tile).join(''); }

        var complete = isComplete();
        var left = 1 - st.picked.length;
        var discount = money(cfg.discounts['2']);
        var l1;
        var l2;
        // Three tiers by info column width (CSS container query): long, medium (no shipping text, no struck price), short.
        var minus = '\u2212' + discount;
        if (complete) {
          var t = totals();
          var shipNote = t.total >= cfg.threshold ? ' \u00b7 ingyenes szállítás' : '';
          l1 = '<strong>' + money(t.total) + '</strong> <s class="velora-stack-bar__full">' + money(t.full) + '</s>';
          l2 = '<span class="velora-stack-bar__long">Megtakarítasz ' + discount + shipNote + '</span>' +
            '<span class="velora-stack-bar__mid">Megtakarítasz ' + discount + '</span>' +
            '<span class="velora-stack-bar__short">' + minus + '</span>';
        } else {
          l1 = '<span class="velora-stack-bar__lm">' + TXT.more(left) + '</span><span class="velora-stack-bar__short">Még ' + left + ' darab</span>';
          l2 = '<span class="velora-stack-bar__long">' + discount + ' kedvezmény' + (ship[2] ? ' \u00b7 ingyenes szállítás' : '') + '</span>' +
            '<span class="velora-stack-bar__mid">' + minus + ' kedvezmény</span>' +
            '<span class="velora-stack-bar__short">' + minus + '</span>';
        }
        if (st.barError) l1 = '<span class="velora-stack-bar__lm">' + TXT.error + '</span><span class="velora-stack-bar__short">' + TXT.errorShort + '</span>';
        setBarHtml(barEls.l1, l1);
        setBarHtml(barEls.l2, l2);
        setText(barEls.btn, st.busy ? TXT.adding : 'Kosárba');
        if (barEls.btn.disabled !== st.busy) barEls.btn.disabled = st.busy;
        setAttr(barEls.btn, 'aria-disabled', complete || st.busy ? 'false' : 'true');
      }
      showBar(setMode && !nativeInView);
    }

    function measureBar() {
      document.documentElement.style.setProperty('--vs-bar-h', bar.offsetHeight + 'px');
    }

    function showBar(visible) {
      if (visible === barOn) { if (visible) measureBar(); return; }
      barOn = visible;
      window.clearTimeout(barHideTimer);
      var root = document.documentElement;
      bar.inert = !visible;
      if (visible) {
        bar.hidden = false;
        void bar.offsetHeight; // start the slide-up from the hidden position
        bar.classList.add('is-on');
        root.classList.add('velora-stack-bar-on');
        measureBar();
      } else {
        bar.classList.remove('is-on');
        root.classList.remove('velora-stack-bar-on');
        root.style.removeProperty('--vs-bar-h');
        if (reduceMotion) bar.hidden = true;
        else barHideTimer = window.setTimeout(function () { if (!barOn) bar.hidden = true; }, 220);
      }
    }

    function onBarClick() {
      if (st.busy) return;
      if (isComplete()) { addSet(); return; }
      // incomplete: bring the choice into view and focus the first card still open
      var rail = root.querySelector('.velora-stack__rail') || root;
      rail.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      var open = pairs.filter(function (p) { return p.available && st.picked.indexOf(p) < 0; })[0];
      if (open) try { open.button.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }

    /* ---------- state changes ---------- */

    function persist() {
      var state = {
        size: st.size,
        mainVariant: st.main.id,
        picked: st.picked.map(function (p) { return p.data.id; }),
        sel: pairs.map(function (p) { return { id: p.data.id, sel: Object.assign({}, p.sel), touched: p.touched, platingSel: p.platingSel }; })
      };
      saved[String(cfg.productId)] = state;
      try { window.sessionStorage.setItem('velora:stack:v1:' + cfg.productId, JSON.stringify(state)); } catch (e) { /* private mode */ }
    }

    function restore() {
      var s = saved[String(cfg.productId)];
      if (!s) {
        try { s = JSON.parse(window.sessionStorage.getItem('velora:stack:v1:' + cfg.productId)); } catch (e) { /* private mode or stale data */ }
      }
      s = restoredStackState(s, window.location.href);
      if (!s) return;
      st.size = stackSize(s.size);
      if (st.size === 1 && Number(s.size) !== 1) { st.picked = []; return; }
      (Array.isArray(s.sel) ? s.sel : []).forEach(function (entry) {
        if (!entry) return;
        pairs.forEach(function (p) {
          if (String(p.data.id) !== String(entry.id)) return;
          p.sel = Object.assign({}, entry.sel);
          p.touched = !!entry.touched;
          p.platingSel = entry.platingSel || null;
        });
      });
      var mainChanged = s.mainVariant === undefined || String(s.mainVariant) !== String(st.main.id);
      pairs.forEach(function (p) { resolvePair(p, mainChanged); });
      st.picked = (Array.isArray(s.picked) ? s.picked : []).map(function (id) {
        return pairs.filter(function (p) { return String(p.data.id) === String(id); })[0];
      }).filter(function (p) { return p && p.available; });
      trimPicked();
    }

    function trimPicked() {
      while (st.picked.length > 1) st.picked.shift();
    }

    function setSize(size) {
      st.size = stackSize(size);
      hideError();
      trimPicked();
      render();
      persist();
      announce();
    }

    // Select one partner; choosing a different card replaces the previous partner.
    function addPick(pair) {
      if (st.picked.indexOf(pair) > -1) return;
      st.picked.push(pair);
      trimPicked();
    }

    // Swatches only select a card when the one partner slot is empty.
    function canAddPick() {
      return st.size === 2 && st.picked.length < 1;
    }

    function togglePair(pair) {
      if (!pair.available || st.size === 1) return;
      var at = st.picked.indexOf(pair);
      if (at > -1) {
        st.picked.splice(at, 1);
      } else {
        addPick(pair);
      }
      hideError();
      render();
      persist();
      announce();
    }

    function announce() {
      try {
        root.dispatchEvent(new CustomEvent('velora:stack-change', {
          bubbles: true,
          detail: { size: st.size, complete: isComplete(), variantIds: [st.main.id].concat(st.picked.map(function (p) { return p.variant.id; })) }
        }));
      } catch (e) { /* ignore */ }
    }

    function showError() {
      if (!els.error) return;
      els.error.textContent = TXT.error;
      els.error.hidden = false;
      st.barError = true;
      window.clearTimeout(st.errorTimer);
      st.errorTimer = window.setTimeout(function () { st.barError = false; renderBar(); }, 4000);
      renderBar();
    }

    function hideError() {
      if (els.error && !els.error.hidden) els.error.hidden = true;
    }

    function syncMain() {
      var v = readMainVariant();
      var changed = v && v !== st.main;
      if (changed) {
        st.main = v;
        pairs.forEach(function (p) { resolvePair(p, true); });
        persist();
      }
      render();
      if (changed) announce();
    }

    /* ---------- add to cart ---------- */

    function addSet() {
      if (st.busy || !isComplete()) return;
      var stackId = newStackId();
      // The cart lists the newest line first, so send the main product LAST:
      // the cart then reads main, chosen pair (top to bottom).
      var ids = [st.picked[0].variant.id, st.main.id];
      var size = '2';
      var items = ids.map(function (id) {
        return { id: id, quantity: 1, properties: { _velora_stack: stackId, _velora_stack_size: size } };
      });
      st.busy = true;
      hideError();
      render();

      function toCart() { window.location.assign(cfg.cartUrl); }

      function failed() {
        // Never resend blindly: look at the cart first, the request may have gone through.
        fetch(cfg.cartJsUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var landed = items.every(function (item) {
              return (cart.items || []).some(function (line) {
                return line.variant_id === item.id && line.properties && line.properties._velora_stack === stackId;
              });
            });
            if (landed) { toCart(); return; }
            throw new Error('not in cart');
          })
          .catch(function () {
            st.busy = false;
            showError();
            render();
          });
      }

      fetch(cfg.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(toCart)
        .catch(failed);
    }

    /* ---------- events ---------- */

    function alive() {
      if (st.destroyed) return false;
      if (!root.isConnected) { destroy(); return false; }
      return true;
    }

    var queued = false;
    function queueSync() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; if (alive()) syncMain(); });
    }

    // Gift tag: opens and closes the gift panel under its row and never selects the row.
    root.addEventListener('click', function (event) {
      var tgl = event.target.closest && event.target.closest('[data-stack-gift-toggle]');
      if (!tgl || !root.contains(tgl)) return;
      event.preventDefault();
      event.stopPropagation();
      var panel = document.getElementById(tgl.getAttribute('aria-controls'));
      if (!panel) return;
      var open = tgl.getAttribute('aria-expanded') !== 'true';
      tgl.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.classList.toggle('is-open', open);
      if (open) panel.removeAttribute('inert'); else panel.setAttribute('inert', '');
    });
    root.addEventListener('keydown', function (event) {
      var tgl = event.target.closest && event.target.closest('[data-stack-gift-toggle]');
      if (tgl && (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar')) event.stopPropagation();
    });

    root.addEventListener('change', function (event) {
      var radio = event.target.closest && event.target.closest('[data-stack-size]');
      if (radio) setSize(Number(radio.value));
    });

    // One handler for the corner button and for taps on the image, name and price (a click, so swipes do not count).
    root.addEventListener('click', function (event) {
      var target = event.target;
      if (!target.closest || target.closest('.velora-stack__swatches, .velora-stack__pill')) return;
      var card = target.closest('[data-stack-card]');
      if (!card || !target.closest('[data-stack-pair], [data-stack-tap]')) return;
      pairs.forEach(function (p) { if (p.card === card) togglePair(p); });
    });

    function isNativeAdd(target) {
      var btn = target && target.closest ? target.closest('button[name="add"], button[type="submit"]') : null;
      var form = mainForm();
      return !!(btn && form && form.contains(btn) && !root.contains(btn));
    }

    // Capture phase: runs before Shrine's own handlers, so only ONE add request is made.
    function onClick(event) {
      if (!alive()) return;
      if (st.size > 1 && st.main.available && isNativeAdd(event.target)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addSet();
      }
    }

    function onSubmit(event) {
      if (!alive()) return;
      var form = mainForm();
      if (form && event.target === form && st.size > 1 && st.main.available) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addSet();
      }
    }

    function onPageShow(event) {
      if (!alive()) return;
      if (event.persisted) { st.busy = false; syncMain(); }
    }

    document.addEventListener('click', onClick, true);
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('change', queueSync);
    document.addEventListener('click', queueSync);
    window.addEventListener('popstate', queueSync);
    window.addEventListener('pageshow', onPageShow);

    // Variant changes: Shrine updates input[name="id"] and re-renders parts of the product form.
    var observer = new MutationObserver(queueSync);
    observer.observe(watchRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled', 'data-unavailable', 'class'] });
    // Light fallback: input.value = ... fires no DOM mutation.
    var timer = window.setInterval(function () { if (alive() && !document.hidden) syncMain(); }, 700);

    function destroy() {
      if (st.destroyed) return;
      st.destroyed = true;
      observer.disconnect();
      window.clearInterval(timer);
      document.removeEventListener('click', onClick, true);
      document.removeEventListener('submit', onSubmit, true);
      document.removeEventListener('change', queueSync);
      document.removeEventListener('click', queueSync);
      window.removeEventListener('popstate', queueSync);
      window.removeEventListener('pageshow', onPageShow);
      window.clearTimeout(st.errorTimer);
      window.clearTimeout(fallbackTimer);
      window.removeEventListener('scroll', onScrollCheck);
      window.removeEventListener('resize', onResizeBar);
      if (barIO) barIO.disconnect();
      // Only clean up when our own bar is still the page's bar (a re-rendered block may already have made a new one).
      if (bar && bar.isConnected) {
        bar.remove();
        document.documentElement.classList.remove('velora-stack-bar-on');
        document.documentElement.removeAttribute('data-velora-stack-set');
        document.documentElement.style.removeProperty('--vs-bar-h');
        document.documentElement.style.removeProperty('--vs-preview-offset');
      }
    }

    /* ---------- start ---------- */

    var initial = readMainVariant();
    if (initial) st.main = initial;
    pairs.forEach(resolvePair);
    restore();
    createBar();
    render();
    persist();
    announce();
    
  }

  /* ---------- scan: init every block once, again after re-renders ---------- */

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll(ROOT), function (root) {
      if (root.getAttribute('data-velora-stack-ready') === '1') return;
      root.setAttribute('data-velora-stack-ready', '1');
      try { init(root); } catch (error) {
        // A broken block must never get in the way of the native buy button.
        root.hidden = true;
        if (window.console && console.warn) console.warn('velora-stack-offer', error);
      }
    });
  }

  window.VeloraStack = { scan: scan };

  var scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(function () {
      scanQueued = false;
      if (document.querySelector(ROOT + ':not([data-velora-stack-ready])')) scan();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
})();
